module.exports = __webpack_public_path__ + "static/img/layout_title.9a8c3c15.png";